import { useEffect, useState } from "react";
import API from "../../../../api";
import { Box, Typography, Stack, LinearProgress, Skeleton } from "@mui/material";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";

const getColor = (level) => {
  if (level <= 30) return "#BFE9FF";
  if (level <= 50) return "#8BD4E6";
  if (level <= 70) return "#6CBEC2";
  return "#459095";
};

const LevelCard = ({ setGeneralLevel }) => {
  const [level,    setLevel]    = useState(null);
  const [countSup, setCountSup] = useState(null);

  useEffect(() => {
    API.getTiresiaLevel().then(res => {
      const v = Math.round(res.data.level * 100) / 100;
      setLevel(v);
      setGeneralLevel?.(res.data.level);
    }).catch(() => setLevel(0));

    API.getTiresia({ reqSup: true }).then(res => {
      setCountSup(res.data ?? 0);
    }).catch(() => setCountSup(0));
  }, [setGeneralLevel]);

  const color = getColor(level ?? 0);

  return (
    <Stack
      direction="row"
      spacing={0}
      divider={<Box sx={{ width: "1px", bgcolor: "#2e2e2e", alignSelf: "stretch" }} />}
      sx={{
        bgcolor: "#1e1e1e",
        border: "1px solid #2e2e2e",
        borderRadius: 1.5,
        overflow: "hidden",
      }}
    >
      {/* ── Training level ── */}
      <Box sx={{ flex: 1, px: 2.5, py: 2 }}>
        <Stack direction="row" alignItems="center" spacing={0.8} sx={{ mb: 1 }}>
          <SchoolOutlinedIcon sx={{ fontSize: 14, color: "#666" }} />
          <Typography sx={{ fontSize: 11, color: "text.secondary" }}>Training level</Typography>
        </Stack>

        <Stack direction="row" alignItems="baseline" spacing={1} sx={{ mb: 1 }}>
          {level !== null ? (
            <Typography sx={{ fontSize: 28, fontWeight: 700, fontFamily: "monospace", color, lineHeight: 1 }}>
              {level}%
            </Typography>
          ) : (
            <Skeleton variant="text" width={70} height={36} sx={{ bgcolor: "rgba(255,255,255,0.07)" }} />
          )}
        </Stack>

        <LinearProgress
          variant="determinate"
          value={level ?? 0}
          sx={{
            height: 4,
            borderRadius: 2,
            bgcolor: "#2e2e2e",
            "& .MuiLinearProgress-bar": { bgcolor: color, borderRadius: 2 },
          }}
        />
      </Box>

      {/* ── Patterns learned ── */}
      <Box sx={{ flex: 1, px: 2.5, py: 2 }}>
        <Stack direction="row" alignItems="center" spacing={0.8} sx={{ mb: 1 }}>
          <AccountTreeOutlinedIcon sx={{ fontSize: 14, color: "#666" }} />
          <Typography sx={{ fontSize: 11, color: "text.secondary" }}>Patterns learned</Typography>
        </Stack>

        {countSup !== null ? (
          <Typography sx={{ fontSize: 28, fontWeight: 700, fontFamily: "monospace", color: "#459095", lineHeight: 1 }}>
            {countSup.toLocaleString()}
          </Typography>
        ) : (
          <Skeleton variant="text" width={80} height={36} sx={{ bgcolor: "rgba(255,255,255,0.07)" }} />
        )}
      </Box>
    </Stack>
  );
};

export default LevelCard;
